// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f52d55b1","239":"9b826020","667":"a4236e39"}[chunkId] + ".chunk.js";
};